
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M256 12.75L196.101 198.1H.001l158.7 115.65-59.899 185.5 157.2-114.5 157.2 114.5-59.899-185.5 158.7-115.65h-196.1z"}})])
      }
    
      }
    